import { ITranslations } from 'types/common';
import en from 'translations/en/productCategoryBasicForm.json';
import pl from 'translations/pl/productCategoryBasicForm.json';
import sl from 'translations/sl/productCategoryBasicForm.json';
import { ProductCategoryBasicFormTransFields } from './types';

export const productCategoryBasicFormTranslations: ITranslations<ProductCategoryBasicFormTransFields> = {
  name: 'productCategoryBasicForm',
  en,
  pl,
  sl,
};
